import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    maxHeight: "100%",
    overflow: "hidden",
  },
  // Sticky header section containing title and navigation
  stickyHeader: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: tokens.colorNeutralBackground1,
    paddingBottom: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    flexShrink: 0,
  },
  // Navigation container matching Resolving style
  navigationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    padding: "8px 12px",
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: "4px",
  },
  positionIndicator: {
    textAlign: "center",
  },
  // Scrollable content area
  scrollableContent: {
    flex: 1,
    overflow: "auto",
    minHeight: 0, // Important for flex overflow to work
  },
  casesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
    gap: "16px",
  },
  caseCard: {
    padding: "16px",
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: "8px",
  },
  caseHeader: {
    marginBottom: "8px",
  },
  caseDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  statusBadge: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
  },
  buttonContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "12px",
    paddingTop: "20px",
    borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
    // Responsive: stack vertically if not enough space
    "@media (max-width: 500px)": {
      flexDirection: "column",
      gap: "8px",
    },
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    paddingTop: "40px",
  },
});
